/** Client-side coordinate normalization (matches backend Street Map handling). */
export function parseCoord(value) {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : parseFloat(String(value).trim());
  return Number.isFinite(n) ? n : null;
}

export function parsePropertyCoords(property) {
  const lat = parseCoord(property?.latitude);
  const lng = parseCoord(property?.longitude);
  if (lat === null || lng === null) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  if (lat === 0 && lng === 0) return null;
  return { lat, lng };
}

export function hasValidPropertyCoords(property) {
  return parsePropertyCoords(property) !== null;
}
